import { render, staticRenderFns } from "./InstructionsPopup.vue?vue&type=template&id=f95e1184"
import script from "./InstructionsPopup.vue?vue&type=script&lang=ts"
export * from "./InstructionsPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports